/** @module utils/cache */

import log from 'utils/log';

/**
 * Massive cache for all things
 *
 * @private
 * @type {object}
 */
let cache_data = {};

/**
 * Get cached value
 *
 * @public
 * @param {!string} key - Key of cached item to fetch
 * @returns {(boolean|*)} - False if key does not exist, otherwise returns the cached value
 */
export function get(key) {
    if (!cache_data.hasOwnProperty(key)) {
        return false;
    }

    // same as for the writing - if we return the actual object, then somebody will likely edit it
    let copy = $.extend({}, cache_data[key]);

    return copy;
}

/**
 * Removes item from cache, if it exists
 *
 * @public
 * @param {!string} key - Key of cache item to remove
 * @returns {void}
 */
export function remove(key) {
    if (!cache_data.hasOwnProperty(key)) {
        return;
    }

    delete cache_data[key];
}

/**
 * Add item to cache. Overrides any existing value w/ same the key.
 *
 * @public
 * @param {string} key - Key
 * @param {*} value - Value to cache
 */
export function cache(key, value) {
    log(`caching value for ${key}`);

    // needs to make a copy or any place that updates the object sent to here
    // could alter the cache version.  this happened in pricing from set_price that adjusts for visible prices
    // in the object returned by cache
    let copy = $.extend({}, value);

    cache_data[key] = copy;
}
